import DashboardLayout from '../components/Dashboard/Layout/DashboardLayout.vue'
// GeneralViews
import NotFound from '../components/GeneralViews/NotFoundPage.vue'
// Dashboard pages
import Overview from 'src/components/Dashboard/Views/Dashboard/Overview.vue'
import Stats from 'src/components/Dashboard/Views/Dashboard/Stats.vue'

// Pages
import User from 'src/components/Dashboard/Views/Pages/UserProfile.vue'
import TimeLine from 'src/components/Dashboard/Views/Pages/TimeLinePage.vue'
import Login from 'src/components/Dashboard/Views/Pages/Login.vue'
import Lock from 'src/components/Dashboard/Views/Pages/Lock.vue'

// Components pages
import Buttons from 'src/components/Dashboard/Views/Components/Buttons.vue'
import GridSystem from 'src/components/Dashboard/Views/Components/GridSystem.vue'
import Panels from 'src/components/Dashboard/Views/Components/Panels.vue'
import SweetAlert from 'src/components/Dashboard/Views/Components/SweetAlert.vue'
import Notifications from 'src/components/Dashboard/Views/Components/Notifications.vue'
import Icons from 'src/components/Dashboard/Views/Components/Icons.vue'
import Typography from 'src/components/Dashboard/Views/Components/Typography.vue'

// Forms pages
import RegularForms from 'src/components/Dashboard/Views/Forms/RegularForms.vue'
import ExtendedForms from 'src/components/Dashboard/Views/Forms/ExtendedForms.vue'
import ValidationForms from 'src/components/Dashboard/Views/Forms/ValidationForms.vue'

// TableList pages
import RegularTables from 'src/components/Dashboard/Views/Tables/RegularTables.vue'
import ExtendedTables from 'src/components/Dashboard/Views/Tables/ExtendedTables.vue'
import PaginatedTables from 'src/components/Dashboard/Views/Tables/PaginatedTables.vue'
// Maps pages
import GoogleMaps from 'src/components/Dashboard/Views/Maps/GoogleMaps.vue'
import FullScreenMap from 'src/components/Dashboard/Views/Maps/FullScreenMap.vue'
import VectorMaps from 'src/components/Dashboard/Views/Maps/VectorMapsPage.vue'

// // Calendar
// import Calendar from 'src/components/Dashboard/Views/Calendar/CalendarRoute.vue'
// // Charts
// import Charts from 'src/components/Dashboard/Views/Charts.vue'
// // Patients
import RegistrationWizard from 'src/components/Dashboard/Views/Patient/RegistrationWizard'
import ResultsWizard from 'src/components/Dashboard/Views/Results/ResultsWizard'
import HomekitWizard from 'src/components/Dashboard/Views/Homekit/HomekitWizard'
import PaymentWizard from 'src/components/Dashboard/Views/Homekit/PaymentWizard'
import RedirectHomekitWizard from 'src/components/Dashboard/Views/Homekit/RedirectHomekitWizard'
import PatientMatchWizard from 'src/components/Dashboard/Views/PatientMatch/PatientMatchWizard'
import HomePage from 'src/components/Dashboard/Views/HomePage'

import SiteSelectionStep from 'src/components/Dashboard/Views/Patient/Wizard/SiteSelectionStep'
import DisclaimerStep from 'src/components/Dashboard/Views/Patient/Wizard/DisclaimerStep'
import ConsentStep from 'src/components/Dashboard/Views/Patient/Wizard/ConsentStep'
import MedicationDataStep from 'src/components/Dashboard/Views/Patient/Wizard/MedicationDataStep'
import InsuranceStep from 'src/components/Dashboard/Views/Patient/Wizard/InsuranceStep'
import SubmissionStep from 'src/components/Dashboard/Views/Patient/Wizard/SubmissionStep'
import CardPage from 'src/components/Dashboard/Views/Homekit/Wizard/CardPage'

import SiteSelectionStepResults from 'src/components/Dashboard/Views/Results/Wizard/SiteSelectionStep'
import Data from 'src/components/Dashboard/Views/Results/Wizard/Data'
import DisclaimerStepResults from 'src/components/Dashboard/Views/Results/Wizard/DisclaimerStep'
import ChooseMethod from 'src/components/Dashboard/Views/Results/Wizard/ChooseMethod'
import CheckConfirmationNumber from 'src/components/Dashboard/Views/Results/Wizard/CheckConfirmationNumber'
import Result from 'src/components/Dashboard/Views/Results/Wizard/Result'

import HomekitRegistration from 'src/components/Dashboard/Views/Homekit/Wizard/HomekitRegistration'

import PatientMatchRegistration from 'src/components/Dashboard/Views/PatientMatch/Wizard/PatientMatchRegistration'

let componentsMenu = {
  path: '/components',
  component: DashboardLayout,
  redirect: '/components/buttons',
  children: [
    {
      path: 'buttons',
      name: 'Buttons',
      component: Buttons
    },
    {
      path: 'grid-system',
      name: 'Grid System',
      component: GridSystem
    },
    {
      path: 'panels',
      name: 'Panels',
      component: Panels
    },
    {
      path: 'sweet-alert',
      name: 'Sweet Alert',
      component: SweetAlert
    },
    {
      path: 'notifications',
      name: 'Notifications',
      component: Notifications
    },
    {
      path: 'icons',
      name: 'Icons',
      component: Icons
    },
    {
      path: 'typography',
      name: 'Typography',
      component: Typography
    }

  ]
}

let formsMenu = {
  path: '/forms',
  component: DashboardLayout,
  redirect: '/forms/regular',
  children: [
    {
      path: 'regular',
      name: 'Regular Forms',
      component: RegularForms
    },
    {
      path: 'extended',
      name: 'Extended Forms',
      component: ExtendedForms
    },
    {
      path: 'validation',
      name: 'Validation Forms',
      component: ValidationForms
    },
    {
      path: 'wizard',
      name: 'RegistrationWizard',
      component: RegistrationWizard
    }
  ]
}

let tablesMenu = {
  path: '/table-list',
  component: DashboardLayout,
  redirect: '/table-list/regular',
  children: [
    {
      path: 'regular',
      name: 'Regular Tables',
      component: RegularTables
    },
    {
      path: 'extended',
      name: 'Extended Tables',
      component: ExtendedTables
    },
    {
      path: 'paginated',
      name: 'Paginated Tables',
      component: PaginatedTables
    }]
}

let mapsMenu = {
  path: '/maps',
  component: DashboardLayout,
  redirect: '/maps/google',
  children: [
    {
      path: 'google',
      name: 'Google Maps',
      component: GoogleMaps
    },
    {
      path: 'full-screen',
      name: 'Full Screen Map',
      component: FullScreenMap
    },
    {
      path: 'vector-map',
      name: 'Vector Map',
      component: VectorMaps
    }
  ]
}

let pagesMenu = {
  path: '/pages',
  component: DashboardLayout,
  redirect: '/pages/user',
  children: [
    {
      path: 'user',
      name: 'User Page',
      component: User
    },
    {
      path: 'timeline',
      name: 'Timeline Page',
      component: TimeLine
    }
  ]
}

let loginPage = {
  path: '/login',
  name: 'Login',
  component: Login
}

let patientRegistration = null
if (String(process.env.ALLOW_REGISTRATION) === 'true') {
  patientRegistration = {
    path: '/patient/register',
    component: DashboardLayout,
    children: [{
      path: '/patient/register',
      name: 'RegistrationWizard',
      component: RegistrationWizard,
      children: [{
        path: '/patient/register/site-selection',
        component: SiteSelectionStep
      },
      {
        path: '/patient/register/disclaimer',
        name: 'DisclaimerStep',
        component: DisclaimerStep
      },
      {
        path: '/patient/register/medical-data',
        name: 'MedicationDataStep',
        component: MedicationDataStep
      },
      {
        path: '/patient/register/consent',
        name: 'ConsentStep',
        component: ConsentStep
      },
      {
        path: '/patient/register/insurance',
        name: 'InsuranceStep',
        component: InsuranceStep
      },
      {
        path: '/patient/register/telehealth',
        name: 'SubmissionStep',
        component: SubmissionStep
      }]
    }]
  }
}

let checkResults = null
if (String(process.env.ALLOW_RESULTS) === 'true') {
  checkResults = {
    path: '/patient/check-results',
    component: DashboardLayout,
    children: [{
      path: '/patient/check-results',
      name: 'ResultsWizard',
      component: ResultsWizard,
      children: [{
        path: '/patient/check-results/site',
        component: SiteSelectionStepResults
      },
      {
        path: '/patient/check-results/medical-data',
        name: 'Data',
        component: Data
      },
      {
        path: '/patient/check-results/disclaimer',
        name: 'DisclaimerStepResults',
        component: DisclaimerStepResults
      },
      {
        path: '/patient/check-results/send-method',
        name: 'ChooseMethod',
        component: ChooseMethod
      },
      {
        path: '/patient/check-results/validation',
        name: 'CheckConfirmationNumber',
        component: CheckConfirmationNumber
      },
      {
        path: '/patient/check-results/results',
        name: 'Result',
        component: Result
      }]
    }
    ]
  }
}

let payment = null
if (String(process.env.ALLOW_PAYMENT) === 'true') {
  payment = {
    path: '/patient/payment/:id',
    component: DashboardLayout,
    children: [{
      path: '/patient/payment/:id',
      name: 'PaymentWizard',
      component: PaymentWizard,
      children: [{
        path: '/patient/payment/:id',
        component: CardPage
      }]
    }]
  }
}

let homekit = {
  path: '/patient/homekit',
  component: DashboardLayout,
  children: [{
    path: '/patient/homekit',
    name: 'HomekitWizard',
    component: HomekitWizard,
    children: [{
      path: '/patient/homekit',
      component: HomekitRegistration
    }]
  }]
}

let patientMatch = {
  path: '/patient/patientMatch',
  component: DashboardLayout,
  children: [{
    path: '/patient/patientMatch',
    name: 'PatientMatch',
    component: PatientMatchWizard,
    children: [{
      path: '/patient/patientMatch',
      component: PatientMatchRegistration
    }]
  }]
}

let homeRedirect = {
  path: '/patient/home/:id',
  component: DashboardLayout,
  children: [{
    path: '/patient/home/:id',
    name: 'RedirectHomekitWizard',
    component: RedirectHomekitWizard,
    children: [{
      path: '/patient/home/:id',
      component: RedirectHomekitWizard
    }]
  }
  ]
}


let lockPage = {
  path: '/lock',
  name: 'Lock',
  component: Lock
}

let routes = []
if (process.env.NODE_ENV === 'production') {
  routes = [
    {
      path: '/',
      component: HomePage
    }
  ]
  if (patientRegistration) {
    routes.push(patientRegistration)
  }
  if (checkResults) {
    routes.push(checkResults)
  }
  if (homekit) {
    routes.push(homekit)
  }
  if (payment) {
    routes.push(payment)
  }
  if (patientMatch) {
    routes.push(patientMatch)
  }
  if (homeRedirect) {
    routes.push(homeRedirect)
  }
  routes.push({ path: '*', component: NotFound })
} else {
  routes = [
    {
      path: '/',
      component: HomePage
    },
    componentsMenu,
    formsMenu,
    tablesMenu,
    mapsMenu,
    pagesMenu,
    loginPage,
    lockPage,
    {
      path: '/admin',
      component: DashboardLayout,
      redirect: '/admin/overview',
      children: [
        {
          path: 'overview',
          name: 'Overview',
          component: Overview
        },
        {
          path: 'stats',
          name: 'Stats',
          component: Stats
        }
      ]
    }
  ]
  if (patientRegistration) {
    routes.push(patientRegistration)
  }
  if (checkResults) {
    routes.push(checkResults)
  }
  if (payment) {
    routes.push(payment)
  }
  if (homekit) {
    routes.push(homekit)
  }
  if (patientMatch) {
    routes.push(patientMatch)
  }
  if (homeRedirect) {
    routes.push(homeRedirect)
  }
  routes.push({ path: '*', component: NotFound })
}
/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
 function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

export default routes



// WEBPACK FOOTER //
// ./src/routes/routes.js